export default {
  SIGNUP: '/signup',
};
